import { useGlobalStore } from './global'
import { storeToRefs } from 'pinia'

// 封装处理
export const useStore = () => {
  let global = useGlobalStore()
  let globalRefs = storeToRefs(global)
  return {
    global: globalRefs.global,
    actions: { ...global },
  }
}

export default { useStore }

